(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/play-page.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/play-page.js');

'use strict';

const {
  useEffect,
  useState
} = React;
const {
  Betslip,
  MapPlay,
  Search,
  HomeButton,
  RightBottomButtons,
  PlayPageContainer,
  Params,
  SearchOverlay,
  Charity
} = svs.lyckoplatsen.components.page_play.react.components;
const {
  useStorageWager
} = svs.lyckoplatsen.page_play.utils;
const {
  mapErrorDialog
} = svs.lyckoplatsen.shared_map.utils;
const jwt = svs.lyckoplatsen.data.config.jwt;
const {
  useResetPlayAtoms
} = svs.lyckoplatsen.components.page_play.react.hooks;
const {
  useSetAtom
} = jotai;
const {
  mapLocationAtom,
  pinLocationAtom,
  shouldShowPinAtom
} = svs.lyckoplatsen.components.page_play.jotai.atoms;
const {
  CONSTANTS
} = svs.lyckoplatsen.components.shared_constants;
const PlayPage = () => {
  useStorageWager();
  const resetPlayAtoms = useResetPlayAtoms();
  const setMapLocation = useSetAtom(mapLocationAtom);
  const setPinLocation = useSetAtom(pinLocationAtom);
  const setShouldShowPin = useSetAtom(shouldShowPinAtom);
  const [isExternal, setIsExternal] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [applyLoadedClass, setApplyLoadedClass] = useState(false);
  useEffect(() => {
    if (!isExternal && applyLoadedClass) {
      var _svs$utils$paramHandl;
      const parsedCoords = (_svs$utils$paramHandl = svs.utils.paramHandler.get({
        key: 'coords'
      })) === null || _svs$utils$paramHandl === void 0 ? void 0 : _svs$utils$paramHandl.value;
      const [lat, lng] = (parsedCoords === null || parsedCoords === void 0 ? void 0 : parsedCoords.split(',').map(Number)) || [];
      setIsExternal(Boolean(parsedCoords));
      if (lat && lng) {
        resetPlayAtoms();
        setMapLocation({
          lat,
          lng,
          zoomLevel: CONSTANTS.FIRST_ZOOM_LEVEL,
          resetView: true,
          delay: 2,
          onStart: mapHandler => {
            mapHandler.placeStartClickCircle({
              lat,
              lng
            });
          }
        });
        svs.utils.paramHandler.remove({
          key: 'coords'
        });
      }
    }
  }, [applyLoadedClass, isExternal, isLoaded, resetPlayAtoms, setMapLocation, setPinLocation, setShouldShowPin]);
  useEffect(() => {
    const timer = setTimeout(() => setIsLoaded(true), 300);
    if (typeof jwt !== 'string' || jwt.length === 0) {
      mapErrorDialog();
    }
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    if (isLoaded) {
      const timer = setTimeout(() => setApplyLoadedClass(true), 30);
      return () => clearTimeout(timer);
    }
  }, [isLoaded]);
  let pageLoadedClass = '';
  if (applyLoadedClass) {
    pageLoadedClass = isExternal ? 'page-loaded-from-start' : 'page-loaded';
  }
  if (!isLoaded) {
    return null;
  }
  return React.createElement(PlayPageContainer, null, React.createElement(Params, null), React.createElement("div", {
    className: "lp-map-play-container relative ".concat(pageLoadedClass)
  }, React.createElement("div", {
    className: "lp-map-play-top"
  }, React.createElement("div", {
    className: "animated-body"
  }, React.createElement(Search, null), React.createElement(HomeButton, null))), isLoaded && React.createElement(MapPlay, {
    nodeId: "map-play"
  }), React.createElement(RightBottomButtons, null), React.createElement(Charity, null), React.createElement(Betslip, null)), React.createElement(SearchOverlay, null));
};
setGlobal('svs.lyckoplatsen.components.page_play.react', {
  PlayPage
});

 })(window);